import React from 'react';
import './ModelLoader.css';

const ModelLoader = () => {
  return (
    <div className="spinner">
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
    </div>
  );
};

export default ModelLoader;
